import React, { useState } from "react";
import Dataa from "./Data";
import Cardd from "./Card";
import Button from "./Buttons";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
const Filter = () => {
  const [item, setItem] = useState(Dataa);

  const menuItems = [...new Set(Dataa.map((Val) => Val.category))];

  const filterItem = (curcat) => {
    const newItem = Dataa.filter((newVal) => {
      return newVal.category === curcat;
    });
    setItem(newItem);
  };
  return (
    <>
      <section className='products' id='products'>
        <Container>
          <h1 className='servhdng prod-hdng'>Our Portfolio</h1>
          <p className='servheadpara prod-para'>Over the years Autoverse have gained significant knowledge and
            work experience in areas like Power Management, Automotive, Network  high-speed interconnect
            protocols and Artificial/Visual computing applications.
          </p>
          <Button
            filterItem={filterItem}
            setItem={setItem}
            menuItems={menuItems}
          />
          <Cardd item={item} />
        </Container>
      </section>
    </>
  );
};

export default Filter;